



















































































import {
    BBadge,
    BButton,
    BCard,
    BCardText,
    BCardTitle,
    BCol,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BPopover,
    BRow,
    BSpinner,
} from "bootstrap-vue";
import { computed, defineComponent, nextTick, onMounted, ref, watch } from "@vue/composition-api";
import useContactLabels from "@/composables/v2.1/useContactLabels";
import Vue from "vue";
import { styleByColor, textColorByBackgroundColor } from "@/utils/color";

// @ts-ignore
import i18n from "@/libs/i18n";
import ContactLabelInterface from "@/interfaces/contactLabel.interface";

export default defineComponent({
    components: {
        BBadge,
        BButton,
        BCard,
        BCardText,
        BCardTitle,
        BPopover,
        BFormInput,
        BListGroup,
        BListGroupItem,
        BSpinner,
        BRow,
        BCol,
    },
    props: {
        value: [],
        contactId: null,
    },
    name: "contactLabels",
    setup(props: { value: ContactLabelInterface[]; contactId: number }, context) {
        const bvModal = context.root.$bvModal;
        const { fetchContactLabels, contactLabels } = useContactLabels(bvModal);

        const isCollapsed = ref(true);
        const searchText = ref("");
        const showCollapse = ref(true);

        const deletingLabels = ref<Record<number, boolean>>({});
        const addingLabels = ref<Record<number, boolean>>({});

        fetchContactLabels({ params: { fields: "name,color", sort: "name,ASC" } });

        const labels = computed<ContactLabelInterface[]>({
            get() {
                return props.value || [];
            },
            set(value) {
                context.emit("input", value);
            },
        });

        const checkShowCollapse = () =>
            nextTick(() => {
                const labelsElement = context.refs.labelsElement as HTMLElement;

                showCollapse.value = labelsElement.clientHeight > 50;
            });

        onMounted(() => checkShowCollapse());

        watch(labels, () => checkShowCollapse(), {
            deep: true,
            immediate: false,
        });

        const selectableLabels = computed(() =>
            contactLabels.value.filter(
                (labelData: ContactLabelInterface) =>
                    labelData.name?.toLowerCase().includes(searchText.value.toLowerCase()) &&
                    labels.value.every((label) => label.id !== labelData.id)
            )
        );

        const removeLabel = (id: number) => {
            const updatedLabels = [...labels.value];
            labels.value = updatedLabels.filter((label) => label.id !== id);
            Vue.set(deletingLabels.value, id, false);
            context.emit("updateLabels", labels);
        };

        const addLabel = (label: any) => {
            const updatedLabels = [...labels.value, label];
            labels.value = updatedLabels;
            Vue.set(addingLabels.value, label.id, false);
            context.emit("updateLabels", labels);
        };

        return {
            showCollapse,
            selectableLabels,
            deletingLabels,
            addingLabels,
            searchText,
            removeLabel,
            addLabel,
            isCollapsed,
            labels,
            textColorByBackgroundColor,
            styleByColor,
        };
    },
});
